
import { getDateDataFromDateCode } from "@utils";

export default {
	name: "AnswerSection",
	props: {
		todayData: {
			required: true,
			type: Object,
		},
		headerElement: {
			type: String,
			default: "h2",
			validator: (val) => /^h\d{1}$/.test(val),
		},
	},
	data() {
		return {
			showAnswer: false,
		};
	},
	computed: {
		answerHeading() {
			if (!this.todayData) {
				return null;
			}

			const date = getDateDataFromDateCode(this.todayData.date);
			const dateString = `${date.month}&nbsp;${date.day},&nbsp;${date.year}`;

			return `Today’s&nbsp;Wordle&nbsp;Answer&nbsp;(#${this.todayData.index}) ${dateString}`;
		},
	},
};
